/**
 * The product decisions behind the kit — ONE place, so changing an answer
 * changes every page built on the kit. The /kit gallery shows each of these.
 *
 * Decided by Ram 2026-10-18 (answers to the 2026-10-17 UX audit), except where
 * marked OPEN.
 */
export const DECISIONS = {
  // #1 Dates: dd/mm/yyyy everywhere on screen, ค.ศ.
  //    พ.ศ. ONLY on printed documents / reports (fmtDocDate).
  //    Exception (Ram, 2026-10-18): the small log / trace line in a printed
  //    document's FOOTER ("Printed … · Treatment ID …") stays ค.ศ. and may be in
  //    English — fmtDocFooterStamp / docFooterLine.
  screenEra: 'CE',

  // #2 Branch 1 สนามเป้า (head office, no clinic):
  //    - forms: never offered (kit/branches.js formBranchOptions)
  //    - filters: not offered; choosing อารีย์ (8) matches อารีย์ AND สนามเป้า
  //      (branchFilterIds) — old สนามเป้า records count as อารีย์
  //    - a row whose branch is 1 displays as อารีย์ (branchName)
  hqBranchId: 1,
  hqMergedInto: 8,

  // #3 After a successful save: a toast that disappears by itself.
  toastOnSave: true,

  // #4 Row click: opens the record's right-hand Drawer OR its detail page —
  //    chosen per page. A PATIENT opens only from their name / surname / HN
  //    (<PatientName>), never from the row.

  // #5 Small screens: the main menu (components/Layout.jsx) must work on a phone.

  // #6 Where a patient link lands, by the context it is clicked from.
  //    Default การรักษา; appointment surfaces → นัดหมาย; Lab tables → Lab.
  patientTabByContext: {
    default: 'treatments',
    appointment: 'appointments',
    lab: 'lab',
    chart: 'chart/history',
    followup: 'follow-ups',
    promotion: 'promotion',
    info: 'info',
  },
}
